import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "CarParkService",
  controller: "BigData",
};

const methods = [
  "GetCarpark_FlowStat_TimePeriod",
  "FindCarCountByMonth",
  "FindCarCountByDay",
  "FindProvinceCount",
  "FindCityCount",
  "FindProvinceCountTop10",
  "FindCityCountTop10"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const CarParkBigDataApi = ZJApi.defineNewApi("CarParkBigDataApi", factory);

export default CarParkBigDataApi;
